module.exports = __webpack_public_path__ + "img/GroupN6.9a2b9132.png";